import React, { useState } from 'react';
import ContainerCard from '../../../../common/components/ContainerCard';
import SHRMButton from '../../../../common/components/SHRMButton';
import { openInNewTabGeneric } from '../../../../common/helpers';
import { IAccount } from '../../../../models/Account/IAccount';
import { exportMembershipCard, exportMembershipCertificate } from '../../../../services';
import styles2 from '../../AccountPage.module.css';
import MembershipCardModal from './components/MembershipCardModal';
import MembershipCertificateModal from './components/MembershipCertModal';
import styles from './MembershipSection.module.css';
import { UserStatus } from '../../../../models/enums';
import { env } from '../../../../env';
import { IMembership } from '../../../../models/Membership/IMembership';

type MembershipSectionProps = {
  accountData: IAccount;
  ssoUUId: string;
  memberhip: IMembership;
  userStatus: UserStatus;
};

const MembershipSection = (props: MembershipSectionProps) => {
  const [isCertificateModalOpen, setIsCertificateModalOpen] = useState(false);
  const [isCardModalOpen, setIsCardModalOpen] = useState(false);

  function navigateRenew() {
    window.open(props.accountData.renewMembershipUrl);
  }

  function navigateJoin() {
    window.open(props.accountData.joinMembershipUrl);
  }

  function navigateManageMembership() {
    window.open(props.accountData.manageMembershipUrl);
  }

  const handlePrintMembership = (isCard: boolean, isLetterSize: boolean) => {
    if (env.REACT_APP_DASHBOARD_API_URL) {
      openInNewTabGeneric(
        env.REACT_APP_DASHBOARD_API_URL +
          (isCard
            ? exportMembershipCard(props.ssoUUId, true)
            : exportMembershipCertificate(props.ssoUUId, true, isLetterSize))
      );
    } else {
      alert('Export membership card / certificate method is undefined!');
    }
  };

  const toggleCertificateModal = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    setIsCertificateModalOpen(!isCertificateModalOpen);
  };

  const toggleCardModal = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    setIsCardModalOpen(!isCardModalOpen);
  };

  const showMemberId =
    props.accountData.memberId &&
    (props.userStatus === UserStatus.GracePeriodMember ||
      props.userStatus === UserStatus.ExpiringMember ||
      props.userStatus === UserStatus.Member);

  const isActiveOrGracePeriodMember = () => {
    return (
      props.userStatus === UserStatus.GracePeriodMember ||
      props.userStatus === UserStatus.ExpiringMember ||
      props.userStatus === UserStatus.Member
    );
  };

  const showRenewalNotice =
    props.accountData.renewalModel && props.accountData.renewalModel.isAutoRenewal;

  const showMemberFeatures =
    props.userStatus === UserStatus.ExpiringMember || props.userStatus === UserStatus.Member;
  return (
    <ContainerCard className={styles2.cardDimensions}>
      <MembershipCertificateModal
        isModalOpen={isCertificateModalOpen}
        closeModal={toggleCertificateModal}
        membership={props.memberhip}
        printCertificate={handlePrintMembership}
      />
      <MembershipCardModal
        isModalOpen={isCardModalOpen}
        closeModal={toggleCardModal}
        membership={props.memberhip}
        expirationDate={props.accountData.membershipExpirationDate}
        printCard={handlePrintMembership}
      />
      <div className={styles.title}>MEMBERSHIP</div>
      {showMemberId && (
        <React.Fragment>
          <div className={styles.subtitleBold}>{props.accountData.membershipType}</div>
          <div className={styles.subtitleRegular}>
            {props.accountData.membershipExpirationLabel}{' '}
            {props.accountData.membershipExpirationDate}
          </div>
        </React.Fragment>
      )}

      {props.accountData.isAutoRenewalWidgetActive && (
        <React.Fragment>
          <p>
            <b>
              Your membership is set to auto-renew and will be charged on{' '}
              {props.accountData.renewalMembershipDate}.
            </b>
          </p>
          <p>You'll receive an email 45 days before your current membership expiration date.</p>
          <SHRMButton onClick={navigateManageMembership}>MANAGE MEMBERSHIP</SHRMButton>
        </React.Fragment>
      )}
      {isActiveOrGracePeriodMember() && !props.accountData.isAutoRenewalWidgetActive && (
        <SHRMButton onClick={navigateRenew}>Renew Now</SHRMButton>
      )}
      {!isActiveOrGracePeriodMember() && !props.accountData.isAutoRenewalWidgetActive && (
        <SHRMButton onClick={navigateJoin}>Join Now</SHRMButton>
      )}

      {showRenewalNotice && (
        <div>
          <strong>
            Your membership will auto-renew on {props.accountData.membershipExpirationDate}.
          </strong>
          <p>You'll receive an email reminder 30 days before your renewal date.</p>
          <br />
          <p>
            <strong>Payment Method</strong>
            <br />
            <i></i> &nbsp; ending in {props.accountData.renewalModel.cardNumber}
          </p>
        </div>
      )}

      {showMemberFeatures && (
        <React.Fragment>
          <hr className={styles.divider} />
          <a className={styles.linkBlue} onClick={toggleCertificateModal}>
            Print Membership Certificate
          </a>
          <a className={styles.linkBlue} onClick={toggleCardModal}>
            Print Membership Card
          </a>
        </React.Fragment>
      )}
    </ContainerCard>
  );
};

export default MembershipSection;
